import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const useDayTripPlanIsRoomPriceFree = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isRoomPriceFree } = viewModel;

	const onSetIsRoomPriceFree = (value: boolean) => {
		onSetViewModel([
			{
				key: "isRoomPriceFree",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isRoomPriceFree,
		onSetIsRoomPriceFree,
	};
};
